import axiosPost from "./axiosPost";

export const RNHServicioGet = async (credentials, data) => {
    const body = {
        service: "RNHServicioGet",
        params: {
            rnhServicioId: data?.id || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
